import { Component, Input } from '@angular/core';

interface TopicItem {
  name: string;
  value: string;
}

@Component({
  selector: 'app-xml-topics',
  templateUrl: './xml-topics.component.html',
  styleUrls: ['./xml-topics.component.scss']
})
export class XmlTopicsComponent {
  private _xmlTopics: TopicItem[];
  get xmlTopics() {
    return this._xmlTopics;
  }

  @Input()
  set xmlTopics(value: any) {
    this._xmlTopics = Object.keys(value).map(k => ({ name: k, value: value[k] }));
  }

  constructor() {}
}
